import { __assign } from "tslib";
import React, { useContext } from "react";
import classNames from "classnames";
import { View } from "../_core/components";
import { pxTransform } from "../_util/px-transform";
import { TaroEnv } from "../_util/env";
import { useConfig } from "../_util/use-config";
var FlexContext = React.createContext({
    based: 12,
    gutter: 32,
});
export function Row(_a) {
    var _b;
    var _c = _a.gutter, gutter = _c === void 0 ? TaroEnv ? 32 : 16 : _c, _d = _a.flexWrap, flexWrap = _d === void 0 ? "wrap" : _d, _e = _a.reverse, reverse = _e === void 0 ? false : _e, _f = _a.align, align = _f === void 0 ? "stretch" : _f, _g = _a.justify, justify = _g === void 0 ? "flex-start" : _g, children = _a.children, className = _a.className, style = _a.style, _h = _a.based, based = _h === void 0 ? 12 : _h;
    var classPrefix = useConfig().classPrefix;
    var flex = null;
    var rowStyle = null;
    // 定义了 gutter 的，才生成一个 flex 上下文，否则使用默认样式即可
    if (typeof gutter === "number") {
        var gutterCompensation = Math.ceil(Number(gutter) / 2) * -1;
        flex = {
            gutter: gutter,
            based: based,
        };
        rowStyle = {
            marginLeft: pxTransform(gutterCompensation, 750),
            marginRight: pxTransform(gutterCompensation, 750),
        };
    }
    rowStyle = __assign(__assign({}, (rowStyle || {})), (style || {}));
    var rowClassName = classNames(classPrefix + "-row", className, (_b = {},
        _b[classPrefix + "-flex-wrap-nowrap"] = flexWrap === "nowrap",
        _b[classPrefix + "-align-items-" + align] = typeof align !== "undefined",
        _b[classPrefix + "-justify-content-" + justify] = typeof justify !== "undefined",
        _b[classPrefix + "-flex-row-reverse"] = reverse,
        _b));
    return (React.createElement(View, { className: rowClassName, style: rowStyle },
        React.createElement(FlexContext.Provider, { value: flex }, children)));
}
export function Col(_a) {
    var _b;
    var children = _a.children, className = _a.className, _c = _a.offset, offset = _c === void 0 ? 0 : _c, _d = _a.order, order = _d === void 0 ? 0 : _d, flexStyle = _a.flex, span = _a.span, style = _a.style;
    var classPrefix = useConfig().classPrefix;
    var flex = useContext(FlexContext);
    var based = flex.based;
    var colStyle = null;
    if (flex) {
        var gutterCompensation = Math.ceil(Number(flex.gutter) / 2);
        colStyle = {
            paddingLeft: pxTransform(gutterCompensation, 750),
            paddingRight: pxTransform(gutterCompensation, 750),
        };
    }
    colStyle = __assign(__assign({}, (colStyle || {})), (style || {}));
    return (React.createElement(View, { className: classNames(classPrefix + "-col", className, (_b = {},
            _b["col-offset-" + offset + "-" + based] = offset >= 1 && offset <= 11,
            _b["col-" + span + "-" + based] = span >= 1 && span <= 12,
            _b)), style: __assign(__assign({}, colStyle), { order: order, flex: flexStyle }) }, children));
}
//# sourceMappingURL=Flex.js.map